<template>
<b-container class="mb-5" v-if="school">
    <h3 class="mb-3">Schule</h3>

    <b-form @submit.prevent="save" autocomplete="on">

      <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="name" label="Name der Schule *" description="*Bitte geben Sie den offiziellen, vollständigen Namen der Schule ein, so wie er dann auch auf den Urkunden stehen soll">
        <b-form-input type="text" v-model="school.name" autocomplete="organization" required/>
      </b-form-group>

      <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="email" label="Email-Adresse der Schule">
        <b-form-input type="text" v-model="school.email" autocomplete="off" required/>
      </b-form-group>

      <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="address" label="Adresse*" description="*Enter für weitere Zeilen">
        <b-form-textarea v-model="school.address" autocomplete="street-address" required/>
      </b-form-group>

      <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="zip" label="Postleitzahl">
        <b-form-input type="text" v-model="school.zip" autocomplete="postal-code" required/>
      </b-form-group>

      <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="city" label="Ort">
        <b-form-input type="text" v-model="school.city" autocomplete="address-level2" required/>
      </b-form-group>

      <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="state" label="Bundesland">
        <form-option-state v-if="country" :country="country" :state="state" :city="school.city" v-on:selected="setState"></form-option-state>
      </b-form-group>

      <b-row class="mt-5">
        <b-col>
          <b-button variant="secondary" v-on:click="school.reset()" v-if="school.changed()">abbrechen</b-button>
        </b-col>

        <b-col class="text-right">
          <b-button variant="primary" v-on:click="saveSchool()" :disabled="!school.changed()">Schuladresse speichern</b-button>
        </b-col>
      </b-row>

    </b-form>


  <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="name" label="Rechnungsadresse">
    <b-checkbox v-model="sameAddress" :disabled="!!invoiceAddress.recipient">Die Rechnungsadresse entspricht der Adresse der Schule</b-checkbox>
  </b-form-group>

  <b-form v-if="!sameAddress && invoiceAddress" autocomplete="on" class="mb-5">
    <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="name" label="Rechnungsempfänger*">
      <b-form-input type="text" v-model="invoiceAddress.recipient" autocomplete="organization" required trim/>
    </b-form-group>

    <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="address1" label="Zeile 1*">
      <b-form-input type="text" v-model="invoiceAddress.line1" autocomplete="street-address" required trim/>
    </b-form-group>

    <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="address2" label="Zeile 2">
      <b-form-input type="text" v-model="invoiceAddress.line2" required trim/>
    </b-form-group>

    <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="address3" label="Zeile 3">
      <b-form-input type="text" v-model="invoiceAddress.line3" required trim/>
    </b-form-group>

    <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="zip" label="Postleitzahl*">
      <b-form-input type="text" v-model="invoiceAddress.zip" autocomplete="postal-code" required trim/>
    </b-form-group>

    <b-form-group label-cols=12 label-cols-lg=4 label-cols-xl=3 label-for="city" label="Ort*">
      <b-form-input type="text" v-model="invoiceAddress.city" autocomplete="address-level2" required trim/>
    </b-form-group>
  </b-form>

  <b-row class="mt-5">
    <b-col>
      <b-button variant="secondary" v-on:click="invoiceAddress.reset()" v-if="invoiceAddress.changed()">abbrechen</b-button>
    </b-col>

    <b-col class="text-right">
      <b-button variant="danger" v-if="!sameAddress && !!invoiceAddress.$.recipient" v-on:click="deleteInvoiceAddress">Rechnungsaddresse löschen</b-button>
      <b-button variant="primary" v-if="!sameAddress" v-on:click="saveInvoiceAddress" :disabled="!invoiceAddress.changed()">Rechnungsadresse speichern</b-button>
    </b-col>
  </b-row>

</b-container>
</template>

<script>
import {School, InvoiceAddress} from '@/models'
import FormOptionState from '@/components/misc/FormOptionState'

export default {
  name: 'School',
  components: {
    FormOptionState: FormOptionState
  },
  data () {
    return {
      country: null,
      state: null,
      sameAddress: true,
      school: null,
      invoiceAddress: null
    }
  },
  mounted () {
    this.showAlerts()
    this.init()
  },

  methods: {
    setState (value) {
      if (this.school.state.code !== value) {
        this.school.state.code = value
        this.school.state.name = ''
      }
    },

    init () {
      const user = this.$parent.getUser()
      if (!user) return

      this.country = user.country

      if (!user.schoolId) {
        this.school = new School({country: user.country})
        this.invoiceAddress = new InvoiceAddress()
        this.country = user.country
        return
      }

      this.school = new School({id: user.schoolId})
      this.school.fetch()
        .then(() => {
          this.state = this.school.state.code
        })

      this.invoiceAddress = new InvoiceAddress({school_id: user.schoolId})
      this.invoiceAddress.fetch()
        .then(() => { this.sameAddress = false })
        .catch(() => { console.log('no invoice address') })
    },

    deleteInvoiceAddress () {
      this.$eventHub.$emit('confirm', 'Rechnungsadresse wirklich löschen?', 'Löschen bestätigen', () => {
        this.invoiceAddress.delete().then(() => { this.sameAddress = true })
      })
    },

    saveInvoiceAddress () {
      let errors = []
      if (this.invoiceAddress.recipient === '') {
        errors.push('Der Empfänger darf nicht leer sein')
      }
      if (this.invoiceAddress.line1 === '') {
        errors.push('Die erste Addresszeile ist vorgeschrieben')
      }
      if (this.invoiceAddress.zip === '') {
        errors.push('Bitte geben Sie eine gültige Postleitzahl an')
      }
      if (this.invoiceAddress.city === '') {
        errors.push('Die Stadt darf nicht leer sein')
      }

      if (errors.length > 0) {
        this.$eventHub.$emit('error', errors.join(',<br/>'))
        return
      }

      this.invoiceAddress.save()
        .then(() => this.$eventHub.$emit('info', 'Rechnungsadresse erfolgreich gespeichert'))
        .catch((e) => this.$eventHub.$emit('error', e))
    },

    saveSchool () {
      this.school.save()
        .then(() => {
          if (!this.$parent.getUser().schoolId) {
            this.axios.get('/users/me')
              .then((rsp) => {
                localStorage.setItem('user', JSON.stringify(rsp.data))
                this.$router.push({name: 'teacher.dashboard', params: {from: 'settings.school.success'}})
              })
          } else {
            this.$eventHub.$emit('info', 'Adresse erfolgreich gespeichert')
          }
        })

        .catch((error) => {
          this.$eventHub.$emit('alertError', error)
        })
    },

    showAlerts () {
      switch (this.$route.params.from) {
        case 'registration':
          this.$eventHub.$emit('alertInfo', 'Email Adresse erfolgreich bestätigt! Bitte tragen Sie nun noch die Kontaktdaten der Schule ein:')
          break

        case 'dashboard':
          this.$eventHub.$emit('alertError', 'Sie müssen zunächst die Daten Ihrer Schule eintragen:')
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/views/users/settings/School.vue